import { useEffect, useRef } from "react";

import styled from "styled-components/macro";
import { padding } from "theme";

import extendedFieldHooks from "ExtendedFields/selectorHooks";

import FnrErrorText from "UI/FnrErrorText/FnrErrorText";

const SDiv = styled("div")`
  ${padding}
`;

const ErrorMessage = () => {
  const [errorMessage] = extendedFieldHooks.useErrorMessage();

  const ref = useRef();

  useEffect(() => {
    if (errorMessage && ref.current.scrollIntoView)
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [errorMessage]);

  return (
    <FnrErrorText ref={ref} error={Boolean(errorMessage)}>
      <SDiv>{errorMessage}</SDiv>
    </FnrErrorText>
  );
};

export default ErrorMessage;
